// Random images/prebuffer script
var theImages = new Array();

theImages[0] = '../images/slide1.jpg';
theImages[1] = '../images/slide2.jpg';
theImages[2] = '../images/slide3.jpg';
theImages[3] = '../images/slide4.jpg';
theImages[4] = '../images/slide5.jpg';
theImages[5] = '../images/slide6.jpg';
theImages[6] = '../images/slide7.jpg';
theImages[7] = '../images/slide8.jpg';
theImages[8] = '../images/slide9.jpg';
theImages[9] = '../images/slide10.jpg';

var p = theImages.length;
var whichImage = Math.round(Math.random() * (p - 1));
function showImage()
{
	var myElem = document.getElementById("loginBkgd");
	myElem.style.backgroundImage = "url(" + theImages[whichImage] + ")";
}